import {Component, OnInit} from '@angular/core';
import {SocketServices} from '../../../CoreModule/services/socket.services';
import {ComisionServices} from '../../services/comision.services';
import {TiendaServices} from '../../../CoreModule/services/tienda.services';
import {NgxSpinnerService} from 'ngx-spinner';
import {Subscription} from 'rxjs';
import {ExcelServices} from '../../../CoreModule/services/excel.services';
import * as moment from 'moment';

@Component({
  selector: 'comision-mensual',
  templateUrl: '../../templates/reportes/reporte.comision.mensual.html',
  styleUrls: ['../../styles/reporte.styles.scss']
})
export class ReporteComisionMensual implements OnInit {

  fecha1: string;
  fecha2: string;

  fechaIni: string;

  fechaFin: string;

  onSendPptoTienda: Subscription;
  onSendPptoCol: Subscription;

  public tData: any[] = [];
  public semanas: string [] = [];

  constructor(private cs: ComisionServices, private ts: TiendaServices, private spinner: NgxSpinnerService, private exs: ExcelServices) {
  }

  ngOnInit(): void {

    this.onSendPptoTienda = this.cs.obsSendPptoTienda.subscribe((d: any) => {

     // let data = d.filter(s=> s.idDB == "036");
      //console.log(data);


      let numCantSemanas = 0;
      if (d) {

     // console.log(d);

        d.map(t => {

          if (t.semanas.length > 0) {

            // if (t.semanas.length > numCantSemanas) {
              // this.semanas = [];
              t.semanas.map(s => {

                let foundSem = this.semanas.find(_s => _s == s.semana);

                if(foundSem == undefined){
                  console.log(s.semana);
                  this.semanas.push(s.semana);
                }

              });
              // numCantSemanas = t.semanas.length;
            // }


            let tienda = {
              co: t.idDB,
              idTienda: t.id,
              nombre: t.nombre,
              ppto: t.ppto,
              totalSem: 0,
              semanas: []
            };

            this.semanas.map(s => {
              let sFind = t.semanas.find(_s => s == _s.semana);
              let pptoSem = 0;

              if (sFind)
                pptoSem = sFind.pptoSem;

              tienda.totalSem += pptoSem;

              tienda.semanas.push({semana: s, ppto: pptoSem});

            });


            this.tData.push(tienda);
          }
        });

      //  console.log(this.semanas);

        // consultar ppto individuales
         this.cs.getPptoCol(this.fechaIni, this.fechaFin);
      } else
        this.spinner.hide();

    });

    this.onSendPptoCol = this.cs.obsSendPptoCol.subscribe((d2: any) => {
      this.spinner.hide();


      if (d2) {
        d2.map((t: any) => {
          let tienda = this.tData.find(td => td.co == t.idDB);


          if (tienda) {
            tienda.detalle = [];
            tienda.pptoCol = t.ppto;

            // if( tienda.totalSem  - tienda.pptoCol){
            //
            // }

            if (Math.abs(tienda.totalSem - tienda.pptoCol) > 0.15) {
              tienda.diferencia = 'diferencia';
              tienda.detalle = this.procesarDiferencia(tienda, t);
            } else {
              tienda.diferencia = '';
            }
          }
        });
      }

    });

  }

  procesarDiferencia(tienda: any, infoCol: any) {
    let detalle: any[] = [];
    tienda.semanas.map((s) => {
      // let pptoColSem = infoCol.colaboradores.map(c => c.semanas.find(cs => cs.semana == s.semana));
      let pptocolXSem = 0;
      infoCol.colaboradores.map(c => {
        let pptoCol = c.semanas.find(cs => cs.semana == s.semana);
        if (pptoCol)
          pptocolXSem += pptoCol.pptoSem;
      });

      if (Math.abs(s.ppto - pptocolXSem) > 0.15) {
        // detalle.push(`Semana ${s.semana} - Ppto Tienda ${Math.round(s.ppto)} - Ppto Col ${Math.round(pptocolXSem)}`);
        let detPeriodo = s.semana.split('-');
        detalle.push(
          {
            ano: detPeriodo[0],
            sem: detPeriodo[1],
            id: tienda.idTienda,
            pptoTienda: s.ppto,
            pptoCol: pptocolXSem
          }
        );
      }

    });

    return detalle;
  }

  consultar() {

    if (this.fecha1 == '' || this.fecha2 == '') {
      alert('Ingrese una fecha valida');
      return;
    }

    this.fechaIni = moment(this.fecha1).format('DD-MM-YYYY');
    this.fechaFin = moment(this.fecha2).format('DD-MM-YYYY');

    // console.log(fechaIni);
    // console.log(fechaFin);
    this.tData = [];
    this.semanas = [];
    // consultar ppto tiendas
    this.spinner.show();
    this.cs.getPptoTienda(this.fechaIni, this.fechaFin);
  }

  exportarExcel() {
    let data: any[] = [];
    for (let d of this.tData) {
      let dt: any = {
        co: d.co,
        tienda: d.nombre
      };


      this.semanas.map((v, i) => {

        dt[v.replace('-', '')] = (d.semanas[i] != undefined) ? d.semanas[i].ppto : "NA";
      });

      dt.totalPpto = d.ppto;
      dt.pptoCol = d.pptoCol;

      data.push(dt);


    }

    this.exs.exportAsExcelFile(data, `consulta ppto ${this.fechaIni} - ${this.fechaFin}`);
  }


}
